import React from "react";
import { imageURl } from "../../libs/env";
export function WrongAnswer(props) {
  return (
    <span class={props.class}>
      <img src={`${imageURl}/wrong.png`} width="17px" alt="" />
    </span>
  );
}
